import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../api/client';
import { formatMoney, formatDate, titleCase } from '../utils/format';
import StatusBadge from '../components/StatusBadge';
import Pagination from '../components/Pagination';
import PageHeader from '../components/PageHeader';

const STATUS_OPTIONS = ['', 'pending', 'completed', 'failed'];

export default function Transactions() {
  const [rows, setRows] = useState([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const [status, setStatus] = useState('');
  const [search, setSearch] = useState('');
  const [loading, setLoading] = useState(true);
  const pageSize = 20;

  useEffect(() => {
    setLoading(true);
    api.get('/transactions', { params: { status: status || undefined, search: search || undefined, page, pageSize } })
      .then((res) => {
        setRows(res.data.data);
        setTotal(res.data.total);
      })
      .finally(() => setLoading(false));
  }, [status, search, page]);

  return (
    <div>
      <PageHeader title="Transactions" subtitle="Payment activity for deposits and settlements." />

      <div className="toolbar">
        <input
          className="search-input"
          placeholder="Search by user, reference or receipt…"
          value={search}
          onChange={(e) => { setSearch(e.target.value); setPage(1); }}
        />
        <select value={status} onChange={(e) => { setStatus(e.target.value); setPage(1); }}>
          {STATUS_OPTIONS.map((s) => (
            <option key={s} value={s}>{s ? s[0].toUpperCase() + s.slice(1) : 'All statuses'}</option>
          ))}
        </select>
      </div>

      <div className="panel">
        <table className="data-table">
          <thead>
            <tr>
              <th>User</th><th>Auction</th><th>Type</th><th>Amount</th>
              <th>Status</th><th>Method</th><th>Date</th>
            </tr>
          </thead>
          <tbody>
            {loading && <tr><td colSpan="7" className="empty-cell">Loading…</td></tr>}
            {!loading && rows.length === 0 && (
              <tr><td colSpan="7" className="empty-cell">No transactions found</td></tr>
            )}
            {!loading && rows.map((t) => (
              <tr key={t.id}>
                <td>{t.username}</td>
                <td>{t.auction_id ? <Link to={`/auctions/${t.auction_id}`}>{t.auction_title}</Link> : '—'}</td>
                <td>{titleCase(t.transaction_type)}</td>
                <td>{formatMoney(t.amount)}</td>
                <td><StatusBadge value={t.status} /></td>
                <td>{t.payment_method || '—'}</td>
                <td>{formatDate(t.created_at)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <Pagination page={page} pageSize={pageSize} total={total} onChange={setPage} />
    </div>
  );
}
